<template>
  <form>
    <fieldset
      class="rf-radio-group flex items-center gap-x-4 gap-y-2"
      :class="{ 'flex-col items-start': vertical }"
    >
      <div v-if="slots.legend || legend" class="text-body text-black-1 inline-block font-semibold!">
        <legend>
          <slot v-if="slots.legend" name="legend"></slot>
          <template v-else-if="legend"
            >{{ legend }}:<span v-if="requiredTitle" class="text-vermillion-50">*</span></template
          >
        </legend>
      </div>

      <div
        class="rf-radio-group--wrapper inline-flex items-center gap-x-4 gap-y-2"
        :class="{ 'flex-col items-start': vertical }"
      >
        <label
          v-for="option in options"
          :key="option.value"
          class="rf-radio-group--radio-label text-black-1 text-body relative inline-flex cursor-pointer gap-2 py-1 [&_input]:cursor-pointer"
          :class="{
            'border-beige-10 border-l border-solid pl-4': option.separate,
            'cursor-not-allowed! opacity-50 [&_input]:cursor-not-allowed!': disabled,
            'items-start': option.description,
            'items-center': !option.description,
          }"
        >
          <span class="h-6! w-6!" style="padding: 2px">
            <input
              v-model="selectedValue"
              type="radio"
              :name="`rf-radio-group-${uid}`"
              :value="option.value"
              :disabled="disabled"
              :aria-required="requiredTitle"
              class="rf-radio-group--radio-input border-beige-20 focus-visible:ring-blue-30 h-5! w-5! appearance-none rounded-full border p-px ring-white transition duration-200 ease-linear ring-inset checked:border-blue-50! checked:bg-blue-50 checked:ring-4 focus-visible:ring-2"
            />
          </span>
          <span class="flex flex-col">
            <span>{{ option.label }}</span>
            <span v-if="option.description" class="text-grey-3 text-xs">
              {{ option.description }}
            </span>
          </span>
        </label>
      </div>
    </fieldset>
  </form>
</template>

<script setup>
import { getCurrentInstance, useSlots } from "vue";

const { uid } = getCurrentInstance();
const slots = useSlots();

const selectedValue = defineModel({ type: [String, Number, Boolean], default: null });

defineProps({
  options: {
    type: Array,
    required: true,
    validator: options => {
      return options.every(
        option =>
          typeof option === "object" &&
          Object.prototype.hasOwnProperty.call(option, "value") &&
          Object.prototype.hasOwnProperty.call(option, "label"),
      );
    },
  },
  legend: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  requiredTitle: { type: Boolean, default: false },
  vertical: { type: Boolean, default: false },
});
</script>
